import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import useOrgUserDetails from 'src/hooks/useOrgUserDetails';
import { useStyles } from './styles';
import { getFullName } from './utils';

const RemoveUser: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  const { removeUser, userDetails } = useOrgUserDetails();
  const name = getFullName(userDetails.firstName, userDetails.lastName);

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const classes = useStyles();

  return (
    <>
      <Button
        onClick={openModal}
        style={{ backgroundColor: '#AC1B16' }}
        data-testid="open-confirmation-modal"
      >
        Remove from organisation
      </Button>

      <Modal
        open={open}
        size="small"
        onClose={closeModal}
        data-testid="confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle onClose={closeModal} data-testid="confirmation-header">
            {`Remove ${name}?`}
          </ModalTitle>
        </Box>
        <ModalContent>
          <Typography
            variant="body1"
            className={classes.modalText}
            data-testid="confirmation-body"
          >
            Are you sure you want to remove{' '}
            {name === 'user' ? name : <strong>{name}</strong>} from your
            organisation?
            <br />
            <br />
            They will no longer have access to any Cambridge services that your
            organisation subscribes to, or any shared data from within your
            organisation.
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={closeModal}
            color="primary"
            variant="text"
            data-testid="cancel-confirmation-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={removeUser}
            variant="contained"
            color="destructive"
            data-testid="confirm-confirmation-modal"
          >
            Remove user
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
export default RemoveUser;
